<ng-container *transloco="let t">
  <section class="confirm-quara-container">
    <div class="flex">
      <popsy-quara-overview
        [amount]="amount"
        [currency]="currency"></popsy-quara-overview>
    </div>
    <span class="fixed-space-32" aria-hidden="true"></span>
    <!-- <button
      class="button popsy-button-primary full-width"
      [disabled]="processingPayment"
      (click)="onPay()">
      <app-loading class="spinner" *ngIf="processingPayment"></app-loading>
      <span *ngIf="!processingPayment">{{ t('action_place_order') }}</span>
    </button> -->
  </section>
</ng-container>
